import styled from 'styled-components'

export const StyledIntensityBar = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`

export const StyledIntensityDot = styled.div<{
  $backgroundColor: string
}>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`
